var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$isObject(_vm.values))?_c('statistik-base',{attrs:{"value":_vm.values,"stats":_vm.statistik}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }